module.exports = __webpack_public_path__ + "img/DE02646.cdf6e098.png";